module.exports = __webpack_public_path__ + "images/b4086cb1b78987c4a245e2b1c19c3486.png";